<template>
  <div>403 Sinulla ei ole oikeutta tarkastella kyseistä sivua.</div>
</template>

<script>
export default {
  name: 'NotFound',
  data: () => {
    return {};
  },
  props: {}
};
</script>

<style scoped></style>
